let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5QWIJ")).then(() => parcelRequire('4geNK'));